import React from "react";

import FormAvatar from "UI/Form/FormAvatar";

function PonudaAvatar() {
  return <FormAvatar ariaLabel="ponuda" icon_word="local_offer" />;
}

export default PonudaAvatar;
